import { appUrl } from 'utils/wrappers';

import ReportsBase from 'app/collections/reports_base';
import FulfillmentThirdPartyFailedOrderReport from 'app/models/fulfillment_third_party_failed_order_report';

export default ReportsBase.extend({
  model: FulfillmentThirdPartyFailedOrderReport,
  url: appUrl('reports/fulfillment_third_party_failed_order'),
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_third_party_failed_order_reports.js